/** Registered onboarding anchors: DOM id + localStorage key per flow */
export const onboardingConfigs = [
  {
    elementId: 'assistant-onboarding-add-to-order',
    storageKey: 'onboarding-assistant',
  },
] as const

export const assistantOnboarding = onboardingConfigs[0]

export const ONBOARDING_ELEMENT_IDS = {
  dashboardPrompt: 'onboarding-dashboard-prompt',
  requestChat: 'onboarding-request-chat',
  requestNav: 'onboarding-request-nav',
} as const

export const ONBOARDING_STORAGE_KEYS = {
  dashboard: 'onboarding-dashboard',
  request: 'onboarding-request',
} as const

export const DEFAULT_ONBOARDING_STORAGE_KEY = 'onboarding-seen'

/** Master switch for customer coach marks. Flip to `true` to show them again. */
export const ONBOARDING_ENABLED = false

/** Above app UI, Radix overlays (often z-50), etc. */
export const ONBOARDING_LAYER_Z_INDEX = 99999

/** Wait for message enter animations (e.g. Framer) before measuring layout */
export const ONBOARDING_SHOW_DELAY_MS = 400

/** Poll until anchor element exists in DOM */
export const ONBOARDING_TARGET_POLL_INTERVAL_MS = 100

/** Stop polling after this many attempts (avoids infinite loop if id is wrong) */
export const ONBOARDING_TARGET_POLL_MAX_ATTEMPTS = 50

/** Padding around highlighted element for the ring */
export const ONBOARDING_RING_PAD_PX = 8

/** Card max width (px); keep in sync with Tailwind `w-[min(280px,...)]` */
export const ONBOARDING_CARD_MAX_WIDTH_PX = 280

/** Rough card height for flip-above/below viewport check */
export const ONBOARDING_CARD_ESTIMATED_HEIGHT_PX = 128

/** Visible connector from the highlight edge to the tooltip */
export const ONBOARDING_CONNECTOR_LENGTH_PX = 40

/** Minimum horizontal inset from viewport edges */
export const ONBOARDING_EDGE_INSET_PX = 16

/** Celebrate before advancing to the next step */
export const ONBOARDING_ACKNOWLEDGE_MS = 700
